import { DateLocale } from '../../../context'
import { getDateLocale } from '../../../utils/locale'

function DateLocaleProvider({ children, language }) {
  return <DateLocale value={getDateLocale(language)}>{children}</DateLocale>
}

export default DateLocaleProvider
